import { useEffect } from 'react';

import { useSegment } from '@telialt/utils/src/segment';

import { ESHOP_MUTATION_KEY } from '../../model';
import { apiDeleteCoupon } from '../../store/api';
import { useCartQuery } from '../queries/useCartQuery';
import { useMutationWithCartRefresh } from './useMutationWithCartRefresh';

export const useDeleteCouponMutation = () => {
    const segment = useSegment();
    const { cartId, cart } = useCartQuery();
    const hasAppliedVoucherWithRemovedDiscounts = cart?.appliedVouchers?.some(
        (voucher) => voucher?.leasingDiscountRemoved || voucher?.giftDiscountRemoved,
    );

    const { mutate, isPending, isError, isIdle } = useMutationWithCartRefresh(
        async () => (await apiDeleteCoupon(segment, { cartId })).data,
        { mutationKey: [ESHOP_MUTATION_KEY.DELETE_COUPON] },
    );
    useEffect(() => {
        if (hasAppliedVoucherWithRemovedDiscounts) {
            mutate();
        }
    }, [hasAppliedVoucherWithRemovedDiscounts, mutate]);

    const isDeleteCouponLoading = (hasAppliedVoucherWithRemovedDiscounts && isIdle) || isPending;
    const isDeleteCouponError = isError;

    return { isDeleteCouponLoading, isDeleteCouponError };
};
